define('app/factories/travel_search_factory',['app/setup',
  'app/views/travel_pages_view',
  'app/views/travel_search_types_view',
  'app/views/travel_search_view',
  'app/views/travel_search_plane_view',
  'app/views/travel_checkout_view',
  'app/models/travel_search_plane_model',
  'app/views/travel_search_train_view',
  'app/models/travel_search_train_model',
  'app/views/travel_search_hotel_view',
  'app/models/travel_search_hotel_model',
  'app/views/travel_hotel_details_view',
  'app/views/travel_hotel_checkout_view',
  'app/views/travel_residence_details_view',
  'app/views/travel_residence_checkout_view'],

  function(takhfifan) {
    var alreadyInit = false;

    if(takhfifan.formKey){
      init();
    }else{
      takhfifan.eventHub.on('formkey', function(formKey) {
        init();
      });
    }

    function init(){
      if(!alreadyInit){

        $('.tkh-travel-search-types').each(function(){
          new takhfifan.travelSearchTypesView({
            el: $(this)
          });
        });

        $('.tkh-travel-search').each(function(){
          new takhfifan.travelSearchView({
            el: $(this)
          });
        });

        $('.tkh-travel-plane-search').each(function(){
          new takhfifan.travelSearchPlaneView({
            el: $(this),
            model: new takhfifan.travelSearchPlaneModel()
          });
        });

        $('.tkh-travel-train-search').each(function(){
          new takhfifan.TravelSearchTrainView({
            el: $(this),
            model: new takhfifan.TravelSearchTrainModel()
          });
        });

        $('.tkh-travel-hotel-search').each(function(){
          new takhfifan.travelSearchHotelView({
            el: $(this),
            model: new takhfifan.travelSearchHotelModel()
          });
        });

        $('.tkh-travel-residence-details').each(function(){
          new takhfifan.travelResidenceDetailsView({
            el: $(this)
          });
        });

        $('.tkh-travel-hotel-checkout').each(function(){
          new takhfifan.travelHotelCheckout({
            el: $(this)
          });
        });

        $('.tkh-travel-residence-checkout').each(function(){
          new takhfifan.travelResidenceCheckout({
            el: $(this)
          });
        });

        $('.tkh-travel-container').each(function(){
          new takhfifan.travelPages({
            el: $(this)
          });
        });

        alreadyInit = true;
      }
    }


  });
